import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Link = styled.a`
	color: ${(props) => props.theme.colors.slateBlue};
	text-decoration: underline;

	&:hover {
		text-decoration: none;

		&:active {
			color: black;
		}
	}
`;

export default function TrialExpiryWarning(props: { expiryDate: Date }) {
	const { t } = useTranslation();

	const diff = props.expiryDate.getTime() - Date.now();
	const days = Math.floor(diff / (1000 * 3600 * 24));

	return (
		<Flex mx={3} flexDirection="row" alignItems="center" flexGrow={1} flexShrink={1}>
			<Box
				style={{
					fontSize: 24,
					flexShrink: 0,
				}}
				mr={3}
			>
				{'🎁'}
			</Box>
			<Box>
				<Box>
					{days > 0
						? t('common.trialExpiryWarning.title', { days })
						: t('common.trialExpiryWarning.expired')}
				</Box>
				<Box>
					<Link href="https://guides.ontreams.com/">{t('common.learnMore')}</Link>
				</Box>
			</Box>
		</Flex>
	);
}
